import { Skeleton } from "antd";
import dayjs from "dayjs";

import { SKELETON_CELL_BASE_STYLES, SKELETON_HEIGHTS, numberPrettyFormatter } from "@regal-voice/ui";
import { JOURNEY_USER_COUNT_CUTOFF_DATE } from "Pages/orchestration/Pages/journeys/constants";
import { JourneyWithMetrics } from "Types/Journey";

export function JourneyStatistics({ record }: { record: JourneyWithMetrics }) {
    const isJourneyCreatedAfterCutoffDate = dayjs(record.originalCreatedAt).isAfter(
        dayjs(JOURNEY_USER_COUNT_CUTOFF_DATE)
    );

    if (isJourneyCreatedAfterCutoffDate) {
        if (record.journeyStats?.loading) {
            return (
                <div data-testid="skeleton">
                    <Skeleton
                        active
                        paragraph={false}
                        style={{ height: SKELETON_HEIGHTS[3], ...SKELETON_CELL_BASE_STYLES }}
                        title={{}}
                    />
                </div>
            );
        }
        return (
            <div key={`${record.id}-statistics-dynamic`}>
                <div>
                    <b>{numberPrettyFormatter(record.journeyStats?.inProgress)}</b> in progress
                </div>
                <div>
                    <b>{numberPrettyFormatter(record.journeyStats?.finished)}</b> finished
                </div>
                <div>
                    <b>{numberPrettyFormatter(record.journeyStats?.stopped)}</b> stopped
                </div>
            </div>
        );
    }

    return (
        <div key={`${record.id}-statistics-static`}>
            <div>
                <b>{record.inProgressJourneys || 0}</b> in progress
            </div>
            <div>
                <b>{record.finishedJourneys || 0}</b> finished
            </div>
        </div>
    );
}
